<template>
    <form novalidate class="md-flex-center-center md-form-input md-login-screen-bg" @submit.prevent="onSubmit">
        <md-card class="md-login-card md-form-card">
            <div class="md-login-img">
                <img class="logo" src="../assets/polsat2.png" alt="logo">
            </div>

            <div class="md-login-title">
                <h1 class="md-login-title">
                    {{ $t('views.login.title') }}
                </h1>
                <p class="md-login-info">{{ $t('views.login.login-title') }}</p>
            </div>

            <div id="buildInfo" class="md-login-build-info">
                <span class="">Env: {{ env }}</span>
                <span class="">Build Info: {{ buildInfo }}</span>
            </div>


            <SnackBar />
            <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-100">
                    <md-field :class="getValidationClass('login')">
                        <label for="login">{{ $t('views.login.form.login') }}</label>
                        <md-input id="login" autocomplete="off" v-model="model.login" :disabled="model.sending" />
                        <span class="md-error" v-if="!$v.model.login.required">{{ $t('validation.required') }}</span>
                    </md-field>
                </div>

                <div class="md-layout-item md-size-100">
                    <md-field :class="getValidationClass('password')">
                        <label for="password">{{ $t('views.login.form.password') }}</label>
                        <md-input id="password" autocomplete="off" v-model="model.password"
                                  :disabled="model.sending" type="password" />
                        <span class="md-error" v-if="!$v.model.password.required">{{ $t('validation.required') }}</span>
                    </md-field>
                </div>
            </div>
            <md-card-actions>
                <md-button type="submit" class="md-header-btn md-login-btn" :disabled="model.sending">
                    {{ $t('views.login.form.submit') }}
                </md-button>
            </md-card-actions>
            <div class="md-login-forgot">
                <router-link to="/password/forgotten">
                    {{ $t('views.login.forgottenPassword') }}
                </router-link>
            </div>
            <md-progress-bar md-mode="indeterminate" v-if="model.sending" />
        </md-card>
        <div v-if="loading" class="loadingCard">
            <md-progress-spinner :md-diameter="200" :md-stroke="20" class="md-accent" md-mode="indeterminate" />
        </div>
    </form>
</template>

<script>
  import {required} from 'vuelidate/lib/validators';
  import {mapActions, mapGetters} from 'vuex';
  import {getRedirectUrlByUserType} from "@/router/utils";
  import store from '../store'
  import i18n from '@/i18n';

  import SnackBar from '@/components/SnackBar'

  export default {
    components: { SnackBar },
    methods: {
      ...mapActions('auth', ['login']),
      ...mapActions('misc', ['getBackendVer']),
      getValidationClass(fieldName) {
      const field = this.$v.model[fieldName];

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          };
        }
      },
      onSubmit() {
        this.$v.$touch();
        this.loading = true
        if(this.$v.$invalid){
          this.loading = false
        }
        if (!this.$v.$invalid) {
          this.model.sending = true;
          this.login({
            login: this.model.login,
            password: this.model.password
          })
              .then((token) => {
                this.$router.push(getRedirectUrlByUserType(token));
              })
              .catch((err) => {
                if(err.message == 'Network Error'){
                  store.commit('snackbar/SNACKBAR_TITLE', i18n.t('error.status.500'))
                  store.commit('snackbar/SNACKBAR_SHOW', true)
                }
                if(err.response?.data.error == 'invalid_grant'){
                  if(err.response?.data?.error_description == "Account disabled") {
                    store.commit('snackbar/SNACKBAR_TITLE', i18n.t('error.code.INACTIVE_ACCOUNT'))
                    store.commit('snackbar/SNACKBAR_SHOW', true)
                  }else{
                    store.commit('snackbar/SNACKBAR_TITLE', i18n.t('error.code.INVALID_USER_CREDINTIALS'))
                    store.commit('snackbar/SNACKBAR_SHOW', true)
                  }
                }
              })
              .finally(() => (this.model.sending = false, this.loading = false));
        }
      }
    },
    validations: {
      model: {
        login: {
          required
        },
        password: {
          required
        }
      }
    },
    data() {
      return {
        model: {
          login: null,
          password: null
        },
        sending: false,
        env: process.env.NODE_ENV,
        loading: false
      };
    },
    mounted() {
      this.getBackendVer();
    },
    computed: {
      ...mapGetters('misc', ['backendVersion']),
      buildInfo: function () {
        return `${process.env.VUE_APP_VERSION} / ${this.backendVersion}`
      }
    }
  };
</script>

<style scoped lang="scss">


    #buildInfo {
        display: flex;
        flex-direction: column;
        font-size: 10px !important;
    }

    .md-toolbar.md-theme-default {
        background-color: #ffffff;
    }
    .md-progress-spinner {
    margin: 50px;
    }
    .loadingCard {
      position:fixed;
      display: flex;
      justify-content: center;
      align-items: center;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0, 0.4);
    }

    .logo{
      width: 165px
    }
</style>
